import(/* webpackMode: "eager", webpackExports: ["WebsiteNav"] */ "/app/components/website-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
